module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.opcoes && _vm.opcoes.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, _vm._l((_vm.opcoes), function(opcao, idx) {
    return _c('div', {
      key: 'op-' + idx,
      staticClass: "col-md-6",
      staticStyle: {
        "padding": "4px 15px"
      }
    }, [_c('label', {
      staticClass: "new-control new-control-checkbox",
      staticStyle: {
        "padding-top": "4px",
        "font-weight": "normal",
        "cursor": "pointer"
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabled
      },
      domProps: {
        "checked": _vm.estaSelecionado(opcao)
      },
      on: {
        "change": function($event) {
          return _vm.alterna(opcao)
        }
      }
    }), _vm._v("\n         " + _vm._s(opcao) + "\n        "), _c('div', {
      staticClass: "new-control-indicator"
    })])])
  }), 0) : _c('div', {
    staticClass: "mensagem",
    staticStyle: {
      "color": "#a8a8a8",
      "font-weight": "normal",
      "font-size": "14px",
      "padding": "4px 0"
    }
  }, [_vm._v("\n    Selecione um Programa para ver os indicadores recomendados, ou adicione indicadores abaixo.\n  ")]), _vm._v(" "), (_vm.extrasVisiveis.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "margin-top": "6px"
    }
  }, _vm._l((_vm.extrasVisiveis), function(item, idx) {
    return _c('div', {
      key: 'ex-' + idx,
      staticClass: "col-md-6",
      staticStyle: {
        "padding": "4px 15px"
      }
    }, [_c('label', {
      staticClass: "new-control new-control-checkbox",
      staticStyle: {
        "padding-top": "4px",
        "font-weight": "normal",
        "cursor": "pointer"
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabled
      },
      domProps: {
        "checked": _vm.estaSelecionado(item.descricao)
      },
      on: {
        "change": function($event) {
          return _vm.alterna(item.descricao, item.custom)
        }
      }
    }), _vm._v("\n         " + _vm._s(item.descricao) + "\n        "), (item.custom) ? _c('span', {
      staticStyle: {
        "color": "#a8a8a8"
      }
    }, [_vm._v(" (livre)")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "new-control-indicator"
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0",
      "margin-top": "8px",
      "align-items": "flex-end"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.novoIndicador),
      expression: "novoIndicador"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255",
      "placeholder": "Adicionar indicador não listado"
    },
    domProps: {
      "value": (_vm.novoIndicador)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.adiciona($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.novoIndicador = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": !_vm.novoIndicador
    },
    on: {
      "click": _vm.adiciona
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3ba4c08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/checklistIndicadores.vue
// module id = 2074
// module chunks = 1